export default __webpack_public_path__ + "static/media/huan.a6c6b51e.png";